import { gql } from "@apollo/client";

export const GET_CARROT_HASH = gql`
  query getCarrotHash {
    getCarrotHash
  }
`;
